import styled from 'styled-components';

import { colors, fontFamily, zIndex } from '../../ui/variables';

export const TypesSelectStyle = styled.div`
  background-color: ${colors.veryDarkGrayishBlue};
  border-radius: 12px;
  padding: 0 16px;
  position: relative;
  width: 100%;

  &.show {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    .show-hide-list {
      .icon {
        transform: translateY(-50%) rotate(180deg);
      }
    }

    .types-list-container {
      ${zIndex.space};
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      max-height: 999em;
    }
  }

  .show-hide-list {
    ${fontFamily.sourceSansPro.bold};
    color: ${colors.verySoftBlue};
    font-size: 14px;
    line-height: 24px;
    position: relative;
    text-align: left;
    width: 100%;

    .show-hide-selected {
      padding: 12px 36px 12px 4px;
      position: relative;
      white-space: nowrap;

      .selected-box {
        border-radius: 6px;
        border-style: solid;
        border-width: 1px;
        height: 22px;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 22px;

        svg {
          fill: ${colors.verySoftBlue};
          height: auto;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
        }
      }
    }

    .show-hide-unselected {
      padding: 12px 48px 12px 0;
      white-space: nowrap;
    }

    .icon {
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;

      svg {
        fill: ${colors.white};
        height: auto;
        width: 100%;
      }
    }
  }

  .types-list-container {
    background-color: ${colors.veryDarkGrayishBlue};
    bottom: 0;
    left: 0;
    max-height: 0;
    overflow: hidden;
    padding: 0 16px;
    position: absolute;
    transform: translateY(100%);
    width: 100%;

    .type-option {
      align-items: center;
      display: flex;
      flex-wrap: nowrap;
      height: 24px;
      justify-content: space-between;
      margin-bottom: 16px;
      padding-left: 32px;
      position: relative;
      width: 100%;

      &.selected {
        .option-box {
          svg {
            fill: ${colors.verySoftBlue};
          }
        }

        .option-name {
          ${fontFamily.sourceSansPro.bold};
        }
      }

      &.type-any {
        border-bottom: solid 1px ${colors.veryPaleBlue};
        height: 40px;
        padding-bottom: 16px;

        .option-box {
          transform: translateY(calc(-50% - 8px));
        }
      }

      .option-box {
        border-radius: 6px;
        border-style: solid;
        border-width: 1px;
        height: 22px;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 22px;

        svg {
          fill: transparent;
          height: auto;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
        }
      }

      .option-name {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.verySoftBlue};
        font-size: 14px;
        line-height: 18px;
      }

      .option-subtypes-count {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.lightGray};
        font-size: 10px;
        line-height: 13px;
      }
    }
  }
`;
